import { render, staticRenderFns } from "./BahiasCRUD.vue?vue&type=template&id=0de59379"
import script from "./BahiasCRUD.vue?vue&type=script&lang=js"
export * from "./BahiasCRUD.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports